import { useState } from 'react';

const STORAGE_KEY = 'calllumi_custom_check_in_events';
const MAX_CUSTOM = 6;

export type SavedCustomEvent = {
  id: string;
  title: string;
  emoji: string;
  iconId: string;
};

function loadFromStorage(): SavedCustomEvent[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed as SavedCustomEvent[];
  } catch {
    return [];
  }
}

function persistToStorage(events: SavedCustomEvent[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(events));
  } catch {
    // ignore
  }
}

/** 直接写入 storage，无需 React 状态（供非组件场景调用） */
export function addCustomEventToStorage(
  title: string,
  emoji: string,
  iconId: string,
): void {
  const prev = loadFromStorage();
  const filtered = prev.filter((e) => e.title.toLowerCase() !== title.toLowerCase());
  const updated = [{ id: title, title, emoji, iconId }, ...filtered].slice(0, MAX_CUSTOM);
  persistToStorage(updated);
}

/** 读取已保存的自定义事件列表（响应式） */
export function useCustomEvents(): SavedCustomEvent[] {
  const [events] = useState<SavedCustomEvent[]>(loadFromStorage);
  return events;
}
